import React from 'react';
import '../css/AuthButton.css';

const AuthButton = () => {
    return (
        <>
      
        <a className='get-started' href='https://bitly.com/' target='_blank' rel='noopener noreferrer'>Naruci odmah !!!</a>
        </>
    )
}

export default AuthButton;